import { render, staticRenderFns } from "./ModalInlineTextArea.vue?vue&type=template&id=00355be2"
import script from "./ModalInlineTextArea.vue?vue&type=script&lang=js"
export * from "./ModalInlineTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00355be2')) {
      api.createRecord('00355be2', component.options)
    } else {
      api.reload('00355be2', component.options)
    }
    module.hot.accept("./ModalInlineTextArea.vue?vue&type=template&id=00355be2", function () {
      api.rerender('00355be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/ModalInlineTextArea.vue"
export default component.exports